import type { EnumUnion } from '@dresscode-frontend/utility-types';
export const DeviceGenre = {
  LAPTOP: 'LAPTOP',
  WORKSTATION: 'WORKSTATION',
  MONITOR: 'MONITOR',
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  SERVER: 'SERVER',
  OTHER: 'OTHER'
} as const;
export type DeviceGenre = EnumUnion<typeof DeviceGenre>;
const deviceGenreValues: ReadonlySet<string> = new Set(Object.values(DeviceGenre));
export function isDeviceGenre(value: unknown): value is DeviceGenre {
  return typeof value === 'string' && deviceGenreValues.has(value);
}